import { authHeader } from '../_helpers';

export const settingsLabelService = {
    getAll,
    get,
    post,
    put,
    remove
};

function remove(id) {
    return authHeader().then(function(token){
        const requestOptions = {
            method: 'DELETE',
            headers: token,
            body: JSON.stringify({id})
        };

        return fetch(`https://${process.env.VUE_APP_API_URL}/settings/labels/${id}`, requestOptions).then(function(response){
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    return Promise.reject(error);
                }
                return data;
            });
        });
    })
}

function post(name) {
    return authHeader().then(function(token){
        const requestOptions = {
            method: 'POST',
            headers: token,
            body: JSON.stringify({name})
        };

        return fetch(`https://${process.env.VUE_APP_API_URL}/settings/labels`, requestOptions).then(function(response){
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                return data;
            });
        });
    })
}

function put(name, id) {
    return authHeader().then(function(token){
        const requestOptions = {
            method: 'PUT',
            headers: token,
            body: JSON.stringify({name, id})
        };

        return fetch(`https://${process.env.VUE_APP_API_URL}/settings/labels`, requestOptions).then(function(response){
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                return data;
            });
        });
    })
}

function getAll() {
    return authHeader().then(function(token){
        const requestOptions = {
            method: 'GET',
            headers: token
        };

        return fetch(`https://${process.env.VUE_APP_API_URL}/settings/labels`, requestOptions).then(function(response){
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                return data;
            });
        });
    })
}

function get(id) {
    return authHeader().then(function(token){
        const requestOptions = {
            method: 'GET',
            headers: token
        };

        return fetch(`https://${process.env.VUE_APP_API_URL}/settings/labels/${id}`, requestOptions).then(function(response){
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    return Promise.reject(error);
                }
                return data;
            });
        });
    })
}
